import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// Create an async thunk for fetching ItemsForSale
export const fetchProject = createAsyncThunk('project/fetchProject', async (projectId) => {
  const response = await fetch(`/api/projects/${projectId}`);
  const data = await response.json();
  return data;
});

const projectSlice = createSlice({
  name: 'project',
  initialState: { project: '', status: 'idle', error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProject.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchProject.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.project = action.payload;
      })
      .addCase(fetchProject.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export default projectSlice.reducer;